import React from "react";
import faq from "../../faq/faq";
import Header from "../../components/Header";
import "./style.scss";

const FAQ = () => {
  return (
    <div className="faq-container">
      <Header title="FAQ" />
      <div className="faqs">
        {faq.map((f, i) => {
          return (
            <div className="faq" key={"" + i}>
              <div className="question">
                <label className="q">{i + 1}.</label>
                <p> {f.question}</p>
              </div>
              <div className="question">
                <label className="q">A.</label>
                <p> {f.answer}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQ;
